module.exports = __webpack_public_path__ + "static/EverForward2-dbf3ef5ee09e7025009c530c46b8185a.webp";